import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useToast } from '@/hooks/useToast';
import { fetchJson } from '@/lib/api';

export const useRunScanMutation = () => {
  const queryClient = useQueryClient();
  const { push } = useToast();

  return useMutation({
    mutationFn: async () =>
      await fetchJson<{ status: string }>('/api/internal/scan', {
        method: 'POST',
      }),
    onError: (error: Error) => push(error.message || 'Scan failed', 'error'),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['daemon-status'] });
      queryClient.invalidateQueries({ queryKey: ['last-scan'] });
      queryClient.invalidateQueries({ queryKey: ['jobs'] });
    },
  });
};
